import { Col, Row } from 'antd'
import React from 'react'
import { AltaCuentaClabe } from './altaCuentaClabe/AltaCuentaClabe'
import { CambioRol } from './cambioRol/CambioRol'
import { SolicitudModeloRefactura } from './solicitudModeloRefactura/SolicitudModeloRefactura'

export const CamposRoles = () => {
  return (
    <Row gutter={10}>
    <Col span={8}><AltaCuentaClabe /></Col>
    <Col span={8}><CambioRol /></Col>
    <Col span={8}><SolicitudModeloRefactura /></Col>



    </Row>
  )
}
